import { Box } from 'ui/Box';
import { FC } from 'react';
import { Header } from '../../modules/LoginModule/components/Header';
import { ReactNode } from 'react';
import { Typography } from 'ui/Typography';
import { AppLogo } from 'app/AppLogo';

export interface ContainerProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
}

export const AuthContainer: FC<ContainerProps> = ({
  title,
  subtitle,
  children,
}) => {
  return (
    <Box className="h-screen w-full p-4">
      <Box className="flex h-full flex-col rounded-3xl bg-light-gray px-4 py-5 md:px-20">
        <Header />
        <Box className="flex flex-1 flex-col items-center justify-center gap-8">
          <Box className="flex flex-col items-center gap-8">
            <Box className="flex items-center !text-mult">
              <AppLogo className="h-14 w-14 md:h-24 md:w-24" />
              <Typography
                variant="h1Roboto"
                className="text-[36px] font-semibold md:text-6xl"
              >
                Hyperlink
              </Typography>
            </Box>
            <Box className="flex flex-col items-center gap-2">
              <Typography
                variant="h2"
                className="max-w-xl text-center text-[28px] text-black md:text-[32px]"
              >
                {title}
              </Typography>
              <Typography className="text-center text-black">
                {subtitle}
              </Typography>
            </Box>
          </Box>
          {children}
        </Box>
      </Box>
    </Box>
  );
};
